import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { PageStateNames } from "../../../../class/PageStateNames";
import { LoginBoxComponent } from "./loginBox/loginBox.component";
import { LoginPageComponent } from "./loginPage/loginPage.component";

export class Config {

    static $inject = ["$stateProvider", "$httpProvider"];

    constructor($stateProvider: StateProvider, /*$translatePartialLoaderProvider: any,*/ $httpProvider: angular.IHttpProvider) {

        $stateProvider.state(PageStateNames.AUTHENTICATION_LOGIN, {

            url: "/pages/auth/login",
            views: {
                "main@": {
                    template: require("../../../../layouts/basic.html")
                },
                "content@app.pages_auth_login": {
                    component: "loginPage"
                }
            },
            data: {
                allowAnonymous: true
            }
        });

        //$translatePartialLoaderProvider.addPart("app/main/pages/auth/login");

        delete $httpProvider.defaults.headers.common["X-Requested-With"];
    }
}

angular
    .module("app.pages.auth.login", ["app.components.fleetMaintenance"])
    .config(Config)
    .component("loginBox", new LoginBoxComponent())
    .component("loginPage", new LoginPageComponent());

